export default __webpack_public_path__ + "static/pragicts-itops-storage-e77479b5973d088a91de583fec6cfcbb.jpg";